import React from 'react';
import { ChevronDown, LogOut, UserRound } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useGetUser } from 'hooks';
import { Urls } from 'data';
import { Avatar, AvatarFallback } from 'components/ui/avatar';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from 'components/ui/dropdown-menu';

const StandaloneAccountMenu = ({ compact = false }) => {
  const navigate = useNavigate();
  const { currentUserFirstname, currentUserLastname, currentUserEmail } = useGetUser();
  const name = `${currentUserFirstname || ''} ${currentUserLastname || ''}`.trim();
  const initials = `${currentUserFirstname?.[0] || ''}${currentUserLastname?.[0] || ''}` || '?';

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className="inline-flex min-h-10 items-center gap-2 rounded-md px-1.5 text-left text-sm text-[#304238] outline-none hover:bg-[#edf3ef] focus-visible:ring-2 focus-visible:ring-hajj-primary"
          aria-label="Ouvrir le menu du compte"
        >
          <Avatar className="size-9 border border-[#cfe0d5]">
            <AvatarFallback className="bg-[#e7f2eb] text-xs font-semibold text-hajj-primary">{initials}</AvatarFallback>
          </Avatar>
          {!compact && <span className="hidden max-w-44 truncate font-medium sm:block">{name}</span>}
          <ChevronDown className="size-3.5 text-[#708078]" aria-hidden="true" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-64 font-[Inter,sans-serif]" align="end">
        <div className="px-2 py-2">
          <p className="truncate text-sm font-semibold text-gray-900">{name}</p>
          <p className="mt-0.5 truncate text-xs text-gray-500">{currentUserEmail}</p>
        </div>
        <DropdownMenuSeparator />
        <DropdownMenuItem onSelect={() => navigate(Urls.userProfile)}>
          <UserRound /> Mon profil
        </DropdownMenuItem>
        <DropdownMenuItem className="text-red-700 focus:text-red-700" onSelect={() => navigate(Urls.front.logout)}>
          <LogOut /> Se déconnecter
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default StandaloneAccountMenu;
